import React from "react"
const Footer = () => {
  return <footer className="footer">
    <p>Copyright &copy; {new Date().getFullYear()} - AKHADAM AYOUB</p>
  </footer>
}

export default Footer
